<!-- src/app/pages/donate/donate.component.html -->
<section class="donate-page">
  <div class="full-width-container">
    <div class="left-column">

      <!-- HERO - sits on dark green background -->
      <div class="hero-section">
        <h1>Unchain Michigan. Fund the Fight.</h1>
        <p class="hero-body">
          I'm running for U.S. Senate as the Libertarian Party nominee because Michigan keeps getting used
          as leverage in Washington, and neither major party is putting us first.
        </p>
        <p class="hero-body">
          I don't have establishment backing or corporate donors.
          <span class="hero-highlight">This campaign runs entirely on people power.</span>
        </p>
        <div class="hero-goal">
          <span class="hero-goal__label">Campaign Goal</span>
          <span class="hero-goal__amount">$250,000</span>
        </div>
      </div>

      <!-- WHITE CONTENT AREA -->
      <div class="content-area">

        <!-- WHY IT MATTERS -->
        <div class="content-section">
          <h2 class="section-heading">Why Your Support Matters</h2>
          <p class="section-body">
            Third-party candidates don't get automatic funding, endorsements, or institutional
            support. Every dollar raised goes directly toward winning Michigan and
            keeping this campaign competitive: canvassing materials, volunteer supplies, outreach,
            compliance, and operations. All powered by people who believe Michigan deserves
            representation without establishment strings attached.
          </p>
        </div>

        <!-- GOTV DRIVE -->
        <div class="content-section">
          <h2 class="section-heading">Donations Power the GOTV Drive</h2>
          <p class="section-body">
            To win on <strong>Election Day, November 3, 2026</strong>, we need 12,000 to 15,000 doors
            knocked across Michigan. That takes real resources. Here is exactly what your donation funds:
          </p>
          <div class="impact-grid">
            <div class="impact-card">
              <div class="impact-amount">$25</div>
              <div class="impact-desc">Prints a pad of door-to-door walk lists - the street-by-street address lists a Captain uses to knock doors</div>
            </div>
            <div class="impact-card">
              <div class="impact-amount">$50</div>
              <div class="impact-desc">Covers supplies for a neighborhood canvassing event</div>
            </div>
            <div class="impact-card">
              <div class="impact-amount">$100</div>
              <div class="impact-desc">Funds outreach materials reaching an entire neighborhood</div>
            </div>
            <div class="impact-card">
              <div class="impact-amount">$1,000</div>
              <div class="impact-desc">Sponsors a full county canvassing push with multiple Captains</div>
            </div>
          </div>
          <p class="volunteer-cta">
            Not able to donate? Become a <strong>Constitutional Captain</strong> and knock
            doors in your community.
            <a routerLink="/volunteer">Sign up here.</a>
          </p>
        </div>

        <!-- DONATE FORM -->
        <div class="donate-form">
          <h2>Donate Today</h2>
          <p>
            Help us raise <strong>$250,000</strong> to win Michigan. Every dollar
            counts and no amount is too small.
          </p>
          <div class="preset-buttons">
            <button type="button" (click)="setDonation(25)"
              [class.preset-active]="selectedAmount === 25">$25</button>
            <button type="button" (click)="setDonation(50)"
              [class.preset-active]="selectedAmount === 50">$50</button>
            <button type="button" (click)="setDonation(100)"
              [class.preset-active]="selectedAmount === 100">$100</button>
            <button type="button" (click)="setDonation(1000)"
              [class.preset-active]="selectedAmount === 1000">$1,000</button>
          </div>
          <p class="note">
            Federal limit: <strong>$3,300 per election.</strong>
            U.S. citizens and permanent residents only.
          </p>

          <!-- DIRECT LINK FALLBACK -->
          <div class="direct-link-notice">
            <span class="direct-link-notice__icon">⚠️</span>
            <p>
              Having trouble with the form below? You can donate directly through our secure
              Donorbox page:
              <a href="https://donorbox.org/lydia-christensen-for-united-states-senate"
                target="_blank" rel="noopener noreferrer">
                click here to open it in a new tab
              </a>.
            </p>
          </div>

          <script src="https://donorbox.org/widget.js" paypalExpress="true"></script>
          <iframe
            src="https://donorbox.org/embed/lydia-christensen-for-united-states-senate?"
            name="donorbox"
            allowpaymentrequest="allowpaymentrequest"
            seamless="seamless"
            frameborder="0"
            scrolling="no"
            height="1500px"
            width="100%"
            style="max-height: none !important;"
            allow="payment">
          </iframe>
        </div>

        <!-- DISCLAIMER -->
        <div class="disclaimer">
          <h2>Legal Disclaimer</h2>
          <p>
            Contributions to Lydia Christensen for United States Senate are used to support
            Lydia Christensen's campaign for U.S. Senate in Michigan in the 2026 election.
            All donations are processed securely through Donorbox and are subject to the
            limits and prohibitions of the Federal Election Commission (FEC).
          </p>
          <ul>
            <li>Only U.S. citizens or lawfully admitted permanent residents may contribute.</li>
            <li>Contributions are not tax-deductible for federal income tax purposes.</li>
            <li>Federal law requires us to collect and report contributor information for donations exceeding $200.</li>
            <li>Individual contribution limits are $3,300 per election.</li>
            <li>Contributions from corporations, labor organizations, national banks, federal contractors, and foreign nationals are prohibited.</li>
          </ul>
          <p>
            For more information, visit
            <a href="https://www.fec.gov" target="_blank" rel="noopener noreferrer">www.fec.gov</a>.
            Paid for by Lydia Christensen for United States Senate, Lydia Christensen, Treasurer.
            FEC ID: C00903575.
          </p>
        </div>

      </div><!-- end content-area -->
    </div><!-- end left-column -->

    <!-- RIGHT COLUMN -->
    <div class="right-column">
      <div class="candidate-image">
        <img src="../assets/lydia-christensen-campaign.jpg" alt="Lydia Christensen, U.S. Senate Candidate">
      </div>
    </div>

  </div>
</section>
